export enum GIFileType {
  contract = 'contract',
  marketing = 'marketing',
  other = 'other'
}
